<h2 class="mb-4">1. WHO WE ARE</h2>

<p class="mb-4">
  <strong>Mobile Media Content, S.L.</strong> (hereinafter
  "<strong>MMC</strong>") is the owner of the Web Site
  <a href="https://3ddigitalvenue.com/" target="_blank"
    >https://3ddigitalvenue.com/</a
  >
  (hereinafter the "Web Site"). MMC is a commercial company of Spanish
  nationality with registered office C/ Àlaba 61, 6th 1 A-2, 08005 Barcelona
  (Spain) and is registered in the Mercantile Registry of Barcelona with Tax
  Identification Number B65799454.
</p>

<p class="mb-4">
  MMC can be reached at:<br />
  <strong>E-mail: </strong>
  <span class="select-none">dpo&#64;mobilemediacontent.com</span>
</p>

<h2 class="mb-4">2. OBJECT</h2>

<p class="mb-4">
  By accessing and using the Website you acquire the status of "User", which
  implies full acceptance of all the provisions of this Legal Notice and the
  rest of the "Legal Texts" including this Legal Notice, the
  <a
    class="cursor-pointer"
    (click)="displaySectionEmitter.emit('Privacy Policy')"
    >Privacy Policy</a
  >
  and the
  <a
    class="cursor-pointer"
    (click)="displaySectionEmitter.emit('Cookie Policy')"
    >Cookies Policy</a
  >. This Legal Notice regulates the access, navigation and use of this Web
  Site, without prejudice that MMC reserves the right to modify the
  presentation, configuration and content of the same, as well as the conditions
  required for its access and/or use. The access and use of the contents of the
  Web Site after the entry into force of its modifications or changes implies
  the acceptance of the same.
</p>

<p class="mb-4">
  This Legal Notice is part of MMC and reserves the right to modify the terms
  and conditions stipulated herein, in whole or in part, by publishing any
  changes in the same form in which they appear in this Legal Notice or through
  any type of communication addressed to users.
</p>

<h2 class="mb-4">3. USE OF THE WEBSITE</h2>

<p class="mb-4">
  The User agrees to make proper, diligent and lawful use of the Website and, in
  particular (i) not to use the Website for illicit and/or illegitimate
  purposes; or illegally (ii) not to use the Website to the detriment of MMC's
  interests (iii) not to use the Website with the purpose of causing damage,
  inefficiencies, interruptions, saturation, or analogous defects in the
  functionality of the Website; including the transmission of malware, viruses
  or similar programs to disseminate or publish offensive, racist, denigrating
  or pornographic content that could cause discomfort to people; (iv) not to
  break the security measures established by MMC (v) not to use the Web Site for
  advertising purposes, such as sending spam or other similar ways;
</p>

<p class="mb-4">
  The User shall be liable for the breach of any of the aforementioned misuse of
  the Web Site, as well as for any loss or damage suffered by MMC due to a
  direct or indirect misuse of the Web Site. For these purposes, MMC may
  exercise all the judicial and extrajudicial actions it deems appropriate.
</p>

<h2 class="mb-4">4. PRIVACY</h2>

<p class="mb-4">
  All data provided to MMC through the Website will be treated by MMC as Data
  Processor, respecting the confidentiality, integrity and availability of
  personal data, in accordance with the
  <a
    class="cursor-pointer"
    (click)="displaySectionEmitter.emit('Privacy Policy')"
    >Privacy Policy</a
  >.
</p>

<h2 class="mb-4">5. COOKIES</h2>

<p class="mb-4">
  The use of cookies on the Website will be regulated in the
  <a
    class="cursor-pointer"
    (click)="displaySectionEmitter.emit('Cookie Policy')"
    >Cookies Policy</a
  >.
</p>

<h2 class="mb-4">6. LINKS</h2>

<p class="mb-4">
  The Web Site may contain links to other web pages in order to complement the
  services offered to the user. MMC is not the owner of these web pages, so it
  is not responsible for their contents or for the damages that the use of them
  may cause to the user.
</p>

<p class="mb-4">
  If the user of the Web Site accesses such web pages and the services they
  offer, MMC shall remain outside any kind of relationship that may be
  established between the user and the owners of such web pages or any third
  parties related to them. Likewise, the owner of a web page in which it intends
  to insert a link to the Web Site must obtain prior authorization from MMC. MMC
  shall not be responsible for the contents of those web pages in which there is
  a link to the Web Site and shall remain outside the relations that may be
  established between the owners of such web pages and the users of the Web
  Site.
</p>

<h2 class="mb-4">7. INDUSTRIAL AND INTELLECTUAL PROPERTY</h2>

<p class="mb-4">
  The intellectual and industrial property rights incorporated in the Web Site,
  the graphic design and computer codes, as well as the distinctive signs and
  trademarks, text, images, videos (hereinafter the "Content") displayed are the
  property of MMC or by the respective Licensor. The User shall use the services
  of the Web Site respecting such ownership and the use of the services shall
  not grant any rights in relation to the Content of the Web Site.
</p>

<p class="mb-4">
  Any use of the Content for which MCC has not expressly authorized, whether
  directly or indirectly for profit or not, including the downloading, storage,
  transmission, public disclosure, distribution, reproduction or transformation,
  in whole or in part, of such content is expressly prohibited, so MMC may
  exercise all judicial and extrajudicial actions it deems appropriate to any
  breach of its rights.
</p>

<h2 class="mb-4">8. RESPONSIBILITY</h2>

<p class="mb-4">
  MMC has made every effort to ensure that the information on the Web Site is
  accurate and up to date. However, MMC makes no warranties or representations
  as to the accuracy and currency of the contents of the Web Site. MMC is not
  responsible for any errors or omissions in the contents of the Web Site and
  reserves the right to change such contents at any time without notice.
</p>

<p class="mb-4">
  The commercial relations between <strong>{{ CUSTOMER_NAME }}</strong> and the
  Users are governed by other general conditions or specific agreements, so that
  the contents of the Web Site do not prevail over such conditions or agreements
  and the Users cannot condition the commercial policy that MMC decides to adopt
  at any time.
</p>

<p class="mb-4">
  MMC is not responsible for any errors or failures in the operation of the Web
  Site, whether intrinsic or due to the characteristics and limitations of the
  Internet. The User assumes any risk arising from the use of the Internet,
  including the possible transmission of computer viruses. MMC does not
  guarantee the uninterrupted operation of the services of the Web Site and
  shall not be liable for any damages that may arise from the interruption of
  the services. In particular, MMC shall not be liable in circumstances of force
  majeure such as fires, strikes and power outages or any other unforeseeable or
  unavoidable events, as well as the improper use of the Web Site by the User in
  accordance with the provisions of this legal notice.
</p>

<p class="mb-4">
  In any case, MMC shall only be liable for damages that were foreseen or could
  have been foreseen at the time of the use of the Website by the user, and
  which are a direct and necessary consequence of a grossly negligent breach of
  substantial contractual obligations.
</p>

<p class="mb-4">
  The fact that the Web Site describes or presents certain services does not
  imply a commitment by MMC that such services will be available to the User.
</p>

<p class="mb-4">
  The exclusion of liability and warranties described in this section shall
  apply to MMC as well as to its directors, officers, employees and
  representatives.
</p>

<h2 class="mb-4">9. MODIFICATIONS</h2>

<p class="mb-4">
  MMC reserves the right to modify this Legal Notice at any time. Changes or
  updates to the Legal Notice, as well as to the Privacy Policy and/or Cookies
  Policy will be explicitly notified to the User through a notice on the
  Website.
</p>

<div class="last-updated">Last modification: 2025/04/01</div>
